/* Testimonial - This line cannot be edited or removed */
export const GET_TESTIMONIALS = "GET_TESTIMONIALS"
export const GET_TESTIMONIALS_SUCCESS = "GET_TESTIMONIALS_SUCCESS"
export const GET_TESTIMONIALS_FAIL = "GET_TESTIMONIALS_FAIL"

/* Testimonial DETAILS */
export const GET_TESTIMONIAL_DETAILS = "GET_TESTIMONIAL_DETAILS"
export const GET_TESTIMONIAL_DETAILS_SUCCESS = "GET_TESTIMONIAL_DETAILS_SUCCESS"
export const GET_TESTIMONIAL_DETAILS_FAIL = "GET_TESTIMONIAL_DETAILS_FAIL"

/* CREATE Testimonial */
export const CREATE_TESTIMONIAL = "CREATE_TESTIMONIAL"
export const CREATE_TESTIMONIAL_SUCCESS = "CREATE_TESTIMONIAL_SUCCESS"
export const CREATE_TESTIMONIAL_FAIL = "CREATE_TESTIMONIAL_FAIL"

/* Edit Testimonial */
export const UPDATE_TESTIMONIAL = "UPDATE_TESTIMONIAL"
export const UPDATE_TESTIMONIAL_SUCCESS = "UPDATE_TESTIMONIAL_SUCCESS"
export const UPDATE_TESTIMONIAL_FAIL = "UPDATE_TESTIMONIAL_FAIL"

/* Delete Testimonial */
export const DELETE_TESTIMONIAL = "DELETE_TESTIMONIAL"
export const DELETE_TESTIMONIAL_SUCCESS = "DELETE_TESTIMONIAL_SUCCESS"
export const DELETE_TESTIMONIAL_FAIL = "DELETE_TESTIMONIAL_FAIL"

